import PropTypes from 'prop-types';
import classnames from 'classnames';
import PanelPropTypes from '../panel/panelPropTypes';

export default function PanelFlap({
  children, panel, visible, updatedPosition,
}) {
  const panelPosition = parseInt(panel.targetPosition, 10);
  const position = panelPosition - updatedPosition;

  return (
    <div
      className={classnames('sidebar-panel-flap', {
        'sidebar-panel-flap-visible': visible,
      })}
      style={{ transform: `translateX(${position}px)` }}
    >
      {children}
    </div>
  );
}

PanelFlap.propTypes = {
  children: PropTypes.node,
  panel: PropTypes.shape(PanelPropTypes),
  visible: PropTypes.bool,
  updatedPosition: PropTypes.number,
};

PanelFlap.defaultProps = {
  children: undefined,
  panel: undefined,
  visible: false,
  updatedPosition: undefined,
};
